import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../shared/api.service';

@Component({
  selector: 'app-unauth-dialog',
  templateUrl: './unauth-dialog.component.html',
  styleUrls: ['./unauth-dialog.component.scss']
})
export class UnauthDialogComponent implements OnInit {
  goBack: String;
  matchLoginUrl: String;
  errorMessage: String = 'Unauthorized Access';

  constructor(
    public dialogRef: MatDialogRef<UnauthDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private apiService:ApiService) {
      this.goBack = apiService.getDefaultRedirectionURL();
      this.matchLoginUrl = apiService.defaultMATCHRedirectionURL;
      this.errorMessage = data.errorMessage || this.errorMessage;
    }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  goToLink(link): void {
    location.assign(link);
  }

}